import React, { useEffect, useState } from 'react';
import { FeedsContainer, Heading, NoComments } from './styles';
import { ManagerLeftArrowIcon } from '../../utils/icons';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { GetFlagPostDetails,GetSocialTipsAndQuotes,/*GetUsersListForFlaggedPost*/ } from '../../redux/constants/apiConstants';
import SingleFeed from './SingleFeed';
// import { useHistory } from "react-router-dom";
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getCommentsOnPost } from '../../redux/actions';
import PropTypes from 'prop-types';
import { getInspirationPost } from '../../redux/actions/socialActions';
import ViewCommentModal from '../ViewCommentModal';
import { t } from 'i18next';
import DeletePostPopup from '../DeletePostPopup/deletePostConfirmation';
import FlaggedUsers from './FlagPost/FlaggedUsers';

function FlagPost({getInspirationPost, fetchCommentsOnPost, user, userCompanyId, history, profileImage, comments, flaggedPostId}) {
  // const history = useHistory();
  const [flagDetails, setFlagDetails] = useState([]);
  // const [userFlagDetails, setUserFlagDetails] = useState([]);
  // const [showAll, setShowAll] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [showViewCommentModal, setshowViewCommentModal]=useState(false);
  const [specialFeed, setSpecialFeed] = useState(null);
  const [selectedFeedId,setSelectedFeedId] = useState(null);
  const[defaultReactions, setdefaultReactions]=useState([]);
  const[editDetails, setEditDetails]=useState();
  const[showEditDeletePopup,setshowEditDeletePopup]=useState();
  const[showEditDeletePopupValue,setshowEditDeletePopupValue]=useState(false);

  const changeEditDeletePopup = (value, feed) => {
    setEditDetails(feed);
    setshowEditDeletePopupValue(value);
  };

  useEffect(()=>{
    showEditDeletePopupValue === "delete" && setshowEditDeletePopup(true)

  },[editDetails, showEditDeletePopupValue]);

  const onHideEditDeletePopup = () => {
    setshowEditDeletePopup('');
    setEditDetails(null);
    setshowEditDeletePopupValue(null);
    // this.setState({
    //   showEditDeletePopup: ''
    // }, () => {
    //   this.openEditAndDelete();
    // })
  };

  const limit = 20;



  useEffect(() => {
    flaggedPostId && getFlagPostDetails(1);
  }, [flaggedPostId]);


  useEffect(() => {
    // Initial API call only once with page = 1
    getFlagPostDetails(1);
  }, []);

  const getFlagPostDetails = async (pageNumber) => {
    if ((!hasMore || loading) && pageNumber !=1) return;

    setLoading(true);
    let apiUrl = `${GetFlagPostDetails}/${userCompanyId}/${pageNumber}/${limit}`;

    try {
      const res = await fetchApi(apiUrl, "GET");

      if (res.status === "success") {
        setFlagDetails((prev) => (pageNumber === 1 ? res.data.posts : [...prev, ...res.data.posts]));
        setHasMore(res.data.pagination.current_page < res.data.pagination.total_pages);
        setPage(res.data.pagination.current_page < res.data.pagination.total_pages ? pageNumber : null);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    if (loading || !hasMore) return;

    const scrollPosition = window.scrollY + window.innerHeight;
    const threshold = document.documentElement.offsetHeight - 100;

    if (scrollPosition >= threshold) {
      getFlagPostDetails(page + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, loading]);



  // const getUsersListForFlaggedPostDetails = async (postId,page) => {

  //   // setIsLoading(true);
    
  //   let apiUrl = `${GetUsersListForFlaggedPost}/${userCompanyId}/${postId}/${page}/5`;
  //   try {
  //     const res = await fetchApi(apiUrl, "GET");
  //     // window.console.log("res for GetFlagPostDetails------",res)
  //     if (res.status === "success") {
  //       setLoading(false);
  //       // setUserFlagDetails(res)
  //     } else {
  //       toast.error(res.data.message);
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     window.console.error(error);
  //     setLoading(false);
  //   } 
  // };


  // const handleShowMore = (index) => {
  //   setShowAll(index);
  // };

  // const handleScroll = () => {
  //   const middleOfScreen = document.body.offsetHeight / 2;
  //   const scrollPosition = window.scrollY + window.innerHeight;
  
  //   // Trigger API call when the scroll reaches the middle
  //   if (scrollPosition >= middleOfScreen && !loading && hasMore) {
  //     setPage((prev) => prev + 1);
  //   }
  // };

  useEffect(() => {
    // getUsersListForFlaggedPostDetails();
    getGlobalAnnouncementData();
  }, []);

  useEffect(() => {
    if (page > 1) {
      getFlagPostDetails(page);
    }
  }, [page]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const renderViewCommentAndGetComment = (feed, id) => {
    setshowViewCommentModal(!showViewCommentModal);
    setSpecialFeed(feed);
    setSelectedFeedId(id);
    // this.setState((prev) => ({
    //   showViewCommentModal: !prev.showViewCommentModal,
    //   specialFeed: feed,
    //   selectedFeedId: id
    // }))
    getInspirationPost(id) ;
    getCommentsForPostModal(id)
    // this.handleScrollTrigger();
  }

  const getCommentsForPostModal = (id) => {
    fetchCommentsOnPost(id);
  };

  const getGlobalAnnouncementData = async()=>{
    const res = await fetchApi(GetSocialTipsAndQuotes + "/" + userCompanyId, "GET");
    setdefaultReactions(res.data.reaction_icons)
  }

  const closeCommentModal = ()=>{
    setshowViewCommentModal(false)
  }




  return (
    <div style={{ margin: "24px auto", width:"1246px" }}>
      <Heading color={"#184A61"}>
        <div className="close-icon" onClick={() => history.goBack()}>
          {ManagerLeftArrowIcon()}
        </div>
        Flagged Posts
      </Heading>
      {flagDetails.length > 0 ? (
        <>
          {flagDetails.map((data) => (
            data && (
              <div key={data.id} style={{ marginBottom: "20px", display:"flex", background:"white",borderRadius:"12px" }}>
                <div style={{ width: '50%',/* borderRight: "1px solid #EFEFEF"*/ }}>
                  <FeedsContainer>
                    <SingleFeed feed={data} hideLikeCommentActivity={true} renderViewCommentAndGetComment={renderViewCommentAndGetComment} selectedFeedId={selectedFeedId} changeEditDeletePopup={changeEditDeletePopup} isFlaggedPost={true}/>
                  </FeedsContainer>
                </div>

                <div style={{ width: "1px", backgroundColor: "#EFEFEF", margin: "16px 16px" }}></div>
                <FlaggedUsers postDetails={data}/>
                {/* <div style={{ width: '50%' }}>
                  <Table padding="8px 0" insight>
                    <div className="heading">This post has been flagged by</div>
                    <div className="type">
                      <div className="name">Employees</div>
                      <div className="value">Reasons</div>
                    </div>
                    {data.flagged_by.slice(0, showAll === index ? data.flagged_by.length : 5).map((item, Index) => (
                      <div className="item" key={Index}>
                        {item.profile_image ? (
                          <div className="profile">
                            <img src={`${ImageUrl}/${item.profile_image}`} alt={item.name} />
                          </div>
                        ) : (
                          <NameInitials style={{marginRight:"8px"}}>{getInitials(item.flagged_by)}</NameInitials>
                        )}
                        <div className="name">{item.flagged_by}</div>
                        <div className="value">{item.reason}</div>
                      </div>
                    ))}
                    {data.flagged_by.length > 5 &&  showAll !== index && (
                      <div className="showmore">
                        <div className="button" onClick={() => handleShowMore(index)}>Show More</div>
                      </div>
                    )}
                  </Table>
                </div> */}
              </div>
            )
          ))}
          {loading && <p>Loading...</p>}
        </>
      ) : (
        <NoComments>No posts in this section</NoComments>
      )}

      {showViewCommentModal && specialFeed ? 
        <ViewCommentModal onClose={closeCommentModal} showModal={showViewCommentModal} feed={specialFeed}
          description={specialFeed.description}
          taggedUsers={specialFeed.shoutout_user_name}
          getCommentsForPost={this.getCommentsForPost}
          changeEditDeletePopup={changeEditDeletePopup}
          // editAndDelete={this.state.editAndDelete}
          // openEditAndDelete={this.state.openEditAndDelete}
          profileImage={profileImage}
          updationList="response"
          commentCount={specialFeed.comment_count}
          history={history}
          // enableTrigger={this.props.enableTrigger}
          key={`feed-${specialFeed.id}`}
          // onChange={this.onChange}
          // handleFeed={this.handleFeed}
          // handleModal={this.handleModal}
          // feedNumber={this.state.feedNumber}
          // data={this.props.postLikeDetails}
          // exemplifiesValues={this.props.exemplifiesValues}
          // showRecognition={this.showRecognition}
          // value={this.state.value}
          // id={this.state.id}
          id={selectedFeedId}
          // image={this.state.image}
          // feedNo={this.state.feedNo}
          // updateFeedsLike={this.props.updateFeedsLike}
          // storedFeeds={this.props.feeds}
          // editPost={this.editPostModel}
          // socialCallBack={this.props.socialCallBack}
          // handlePhotoPostModal={this.handlePhotoPostModal}
          comments={comments}
          // postReply={this.props.postReplyOnComment}
          // replySuccess={this.props.replySuccess}
          user={user}
          defaultReactions={defaultReactions}
          isFlaggedPost={true}
        /> : null}

      <DeletePostPopup
        feed={editDetails}
        showModal={showEditDeletePopup}
        onClose={onHideEditDeletePopup}
        updationList="response"
        title={t("DELETE POST")}
        subContent={t("This action cannot be undone.")}
        isFlaggedPost={true}
      />
    </div>
  );
}

FlagPost.propTypes = {
  getInspirationPost: PropTypes.func,
  fetchCommentsOnPost:PropTypes.func,
  user:PropTypes.object,
  userCompanyId:PropTypes.number,
  history:PropTypes.object,
  profileImage:PropTypes.string,
  comments:PropTypes.array,
  flaggedPostId:PropTypes.number
}

const mapStateToProps = (state) => ({
  user: state.profileData.user,
  userCompanyId: state.profileData.companyDetails.id,
  profileImage: state.profileData.profileImage,
  comments: state.social.comments,
  flaggedPostId: state.social.flaggedPostId,
});

const mapDispatchToProps = (dispatch) => ({
  getInspirationPost: (id) => dispatch(getInspirationPost(id)),
  fetchCommentsOnPost: (id) => dispatch(getCommentsOnPost(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(FlagPost)));

